import { useState, useEffect, useCallback } from 'react';
import { dockerService } from '../services/dockerService';

/**
 * useContainers Hook
 * Manages container list state and fetching
 */
export function useContainers() {
  const [containers, setContainers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchContainers = useCallback(async () => {
    try {
      setLoading(true);
      const data = await dockerService.getContainers();
      setContainers(data.containers || []);
      setError(null);
    } catch (err) {
      console.error('Error fetching containers:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchContainers();
  }, [fetchContainers]);

  return {
    containers,
    loading,
    error,
    refresh: fetchContainers
  };
}
